(() => {
  const initialiseCartLimits = (scope = document) => {
    scope.querySelectorAll('[data-cart-quantity]').forEach((input) => {
      if (input.dataset.quantityLimitReady === 'true') return;
      input.dataset.quantityLimitReady = 'true';

      const validate = () => {
        const form = input.closest('[data-cart-quantity-form]');
        const requested = Number(input.value || 0);
        const otherProductQuantity = Math.max(0, Number(input.dataset.otherProductQuantity || 0));
        const stockQuantity = Math.max(0, Number(input.dataset.stockQuantity || 0));
        const inventoryTracked = input.dataset.inventoryTracked === 'true';
        let message = '';

        if (otherProductQuantity + requested > 5) message = form?.dataset.limitMessage || '';
        else if (inventoryTracked && requested > stockQuantity) {
          message = stockQuantity > 0
            ? (form?.dataset.stockMessage || '').replace('COUNT_TOKEN', String(stockQuantity))
            : form?.dataset.stockNoneMessage || '';
        }

        input.setCustomValidity(message);
      };

      input.addEventListener('input', validate);
      input.addEventListener('change', validate);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseCartLimits());
  else initialiseCartLimits();

  document.addEventListener('shopify:section:load', (event) => initialiseCartLimits(event.target));
})();
